import { ActionIcon, CopyButton, Group, Stack } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import {
  IconBrandFacebook,
  IconBrandReddit,
  IconBrandTwitter,
  IconBrandWhatsapp,
  IconCopy,
} from "@tabler/icons-react";
import {
  FacebookShareButton,
  RedditShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "next-share";
import { trackEvent } from "./analytics";
import { Board } from "./boards/board.schema";
import { Member } from "./members/member.schema";
import { Event, EventType } from "./events/event.schema";
import { getBoardLink, getMemberLink, getSiteUrl, getEventLink } from "./util";
import PromptTip from "../components/common/PromptTip";
import { useIsBoardAdmin } from "./boards/board.hooks";
const SocialShare = ({
  board,
  member,
  event,
}: {
  board: Board;
  member?: Member;
  event?: Event;
}) => {
  const isAdmin = useIsBoardAdmin();
  let promptShare = false;
  let promptName = `fb-share`;
  let tip =
    "Don't forget to share the results of your tournament on your club's social media pages";
  let url = `${getSiteUrl()}${getBoardLink(board)}`;
  let title = `Check out the latest results for ${board.name}`;
  if (member) {
    url = `${getSiteUrl()}${getMemberLink(board, member)}`;
    title = `Check out the latest results for ${board.name}: ${member.name}`;
  }
  if (event) {
    url = `${getSiteUrl()}${getEventLink(board, event)}`;
    title = `Check out the latest results for ${board.name}: ${event.name}`;
    promptName = `fb-share-${event.shortLink}`;
    if (event.complete && event.eventType === EventType.TOURNAMENT) {
      promptName = `fb-share-results`;
      //event.completeDate is within 48 hours
      const recent =
        new Date(event.completeDate).getTime() > Date.now() - 172800000;
      promptShare = event.complete && recent && isAdmin;
      // console.log("isAdmin :", isAdmin);
      // console.log("recent :", recent);
    }
    // console.log("event.openRegistration :", event.openRegistration);
    // console.log("event.started :", event.started);
    if (!event.started && event.openRegistration) {
      promptName = `fb-share-registration`;
      tip =
        "Don't forget to share the registration for your event on your club's social media page";
      //recent = within last week
      const recent =
        new Date(event.createdAt).getTime() > Date.now() - 604800000;
      // console.log("recent :", recent);
      promptShare = event.openRegistration && isAdmin && recent;
    }
  }
  if (event?.openRegistration && !event.started) {
    url = `${getSiteUrl()}${getEventLink(board, event)}`;
    title = `Register and check out the latest results for ${board.name}: ${event.name}`;
  }
  const variant = "light";
  return (
    <Stack>
      <Group>
        <PromptTip disabled={!promptShare} name={promptName} tip={tip}>
          <FacebookShareButton url={url} quote={title}>
            <ActionIcon
              component="div"
              color="blue"
              variant={variant}
              onClick={() => {
                trackEvent("open_facebook_share", {
                  board: board.shortLink,
                });
              }}
            >
              <IconBrandFacebook size={18} />
            </ActionIcon>
          </FacebookShareButton>
        </PromptTip>
        <TwitterShareButton url={url} title={title}>
          <ActionIcon
            component="div"
            color="cyan"
            variant={variant}
            onClick={() => {
              trackEvent("open_twitter_share", {
                board: board.shortLink,
              });
            }}
          >
            <IconBrandTwitter size={18} />
          </ActionIcon>
        </TwitterShareButton>
        <WhatsappShareButton url={url} title={title}>
          <ActionIcon
            component="div"
            color="green"
            variant={variant}
            onClick={() => {
              trackEvent("open_whatsapp_share", {
                board: board.shortLink,
              });
            }}
          >
            <IconBrandWhatsapp size={18} />
          </ActionIcon>
        </WhatsappShareButton>
        <RedditShareButton url={url} title={title}>
          <ActionIcon
            component="div"
            color="red"
            variant={variant}
            onClick={() => {
              trackEvent("open_reddit_share", {
                board: board.shortLink,
              });
            }}
          >
            <IconBrandReddit size={18} />
          </ActionIcon>
        </RedditShareButton>
        <CopyButton value={url}>
          {({ copy }) => (
            <ActionIcon
              component="div"
              variant={variant}
              onClick={() => {
                trackEvent("copy_board_link", {
                  board: board.shortLink,
                });
                showNotification({
                  message: "Copied",
                  autoClose: true,
                  color: "success",
                });
                copy();
              }}
            >
              <IconCopy size={18} />
            </ActionIcon>
          )}
        </CopyButton>
      </Group>
    </Stack>
  );
};
export default SocialShare;
